import React, { useEffect, useState } from "react";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";

import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";

import {
  Box,
  Button,
  Pagination,
  Paper,
  Skeleton,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";

import ArrowBackIcon from "@mui/icons-material/ArrowBack";

import dayjs from "dayjs";
import duration from "dayjs/plugin/duration";
import relativeTime from "dayjs/plugin/relativeTime";
import { apiCall } from "../../../API/apiCall";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import moment from "moment";
import GenericTable from "../../common/MUIDataTable";

dayjs.extend(duration);
dayjs.extend(relativeTime);

const pickerStyle = {
  "& .MuiOutlinedInput-root": {
    "& fieldset": { borderColor: "#6e3fc9" },
    "&:hover fieldset": { borderColor: "#4a2b8a" },
    "&.Mui-focused fieldset": { borderColor: "#4a2b8a" },
    "&.Mui-focused": { backgroundColor: "#f2ecfc" },
  },
};

const headerCellSx = {
  backgroundColor: "#6a3fc9",
  color: "white",
  fontWeight: "bold",
  position: "sticky",
  top: 0,
  zIndex: 3,
};

// const columns = [
//   {
//     id: "sno",
//     label: "S.No",
//     align: "left",
//   },
//   {
//     id: "Email",
//     label: "Email",
//     align: "left",
//   },
//   {
//     id: "loginAt",
//     label: "Last Login",
//     align: "left",
//   },
//   {
//     id: "logoutAt",
//     label: "Last Logout",
//     align: "left",
//   },
//   {
//     id: "durationMs",
//     label: "Duration",
//     align: "left",
//   },
// ];

const UserActivity = () => {
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();
  const { id } = useParams();
  const [data, setData] = useState([]);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [pagination, setPagination] = useState(null);
  const [page, setPage] = useState(Number(searchParams.get("page")) || 1);
  const limit = 5;

  useEffect(() => {
    (async function () {
      try {
        console.log("DDDDDD : ", endDate);
        setIsLoading(true);
        const response = await apiCall({
          url: `sessions-reports/${id}`,
          method: "GET",
          params: {
            page: page || 1,
            limit: limit,
            "loginAt[gte]": startDate,
            "loginAt[lt]": endDate
              ? moment(endDate)?.add(1, "day")?.startOf("day")
              : endDate,
          },
        });

        if (response?.status === "success") {
          setData(response?.data?.data);
          setPagination(response.pagination);
        }
      } catch (error) {
        console.log("Error : ", error);
      } finally {
        setIsLoading(false);
      }
    })();
  }, [id, startDate, endDate, page]);

  const formatDateTime = (date) => {
    return date ? dayjs(date).format("DD MMM YYYY, hh:mm A") : "-";
  };

  // Function to handle date change.
  const handleStartDateChange = (newDate) => {
    setStartDate(moment(newDate).startOf("day"));
  };
  const handleEndDateChange = (newDate) => {
    setEndDate(moment(newDate).startOf("day"));
    // setEndDate(moment(newDate).add(1, "day").startOf("day"));
  };

  // Function to handle page change.
  const handlePageChange = (value) => {
    setPage(value);
    setSearchParams(
      (prev) => {
        prev.set("page", Number(value));
        return prev;
      },
      { replace: true }
    );
  };

  const loginHistoryColumns = (page, limit, formatDateTime) => [
    {
      id: "sno",
      label: "S.No",
      align: "left",
      render: (_, index) => (page - 1) * limit + index + 1,
    },
    {
      id: "email",
      label: "Email",
      align: "left",
      render: (row) => row?.user?.Email || "N/A",
    },
    {
      id: "loginAt",
      label: "Login Time / Status",
      align: "left",
      render: (row) => formatDateTime(row?.loginAt),
    },
    {
      id: "logoutAt",
      label: "Logout Time / Status",
      align: "left",
      render: (row) => {
        if (row?.logoutAt) {
          return formatDateTime(row?.logoutAt);
        }
        // Check if 24 hours have passed since login
        const isAutoExpired = dayjs(row?.loginAt)
          .add(24, "hour")
          .isBefore(dayjs());
        return isAutoExpired
          ? formatDateTime(dayjs(row?.loginAt).add(24, "hour"))
          : "Active";
      },
    },
    {
      id: "duration",
      label: "Duration",
      align: "left",
      render: (row) => {
        const login = dayjs(row?.loginAt);
        const logout = row?.logoutAt ? dayjs(row?.logoutAt) : null;

        if (login.isValid() && logout?.isValid()) {
          return dayjs.duration(logout.diff(login)).humanize();
        }

        if (row?.logoutAt || row.lastLogin) {
          return "Active";
        }

        // Default to 24-hour duration calculation if still active/auto-expiring
        return dayjs
          .duration(dayjs(row?.loginAt).add(24, "hour").diff(login))
          .humanize();
      },
    },
  ];

  const columns = loginHistoryColumns(page, limit, formatDateTime);

  return (
    <>
      <section>
        <div className="container">
          <Button
            variant="outlined"
            startIcon={<ArrowBackIcon />}
            onClick={() => navigate(-1)}
            sx={{
              color: "#6e3fc9",
              borderColor: "#6e3fc9",
              textTransform: "uppercase",
              fontWeight: "bold",
              letterSpacing: "1px",

              "&:hover": {
                backgroundColor: "#f2ecfc",
                borderColor: "#4a2b8a",
                color: "#4a2b8a",
              },
            }}
          >
            Go Back
          </Button>
          <div className="row align-items-center">
            <div className="col-xl-12 col-lg-12 col-md-12 col-12">
              <div className="mid_banner">
                <h2>
                  User Activity <span>Report</span>
                </h2>
              </div>
            </div>
          </div>
        </div>
      </section>
      <div className="container">
        <LocalizationProvider dateAdapter={AdapterMoment}>
          <Stack
            direction={{ xs: "column", sm: "row" }}
            justifyContent="flex-end"
            spacing={2}
          >
            {[
              { label: "From", value: startDate, fn: handleStartDateChange },
              { label: "To", value: endDate, fn: handleEndDateChange },
            ].map((d) => (
              <Box
                key={d.label}
                sx={{ display: "flex", alignItems: "center", gap: 1 }}
              >
                <Typography
                  sx={{
                    color: "#6e3fc9",
                    fontWeight: "bold",
                    textTransform: "uppercase",
                    fontSize: "14px",
                  }}
                >
                  {d.label}:
                </Typography>
                <DatePicker
                  value={d.value}
                  onChange={d.fn}
                  sx={pickerStyle}
                  format="MM/DD/YYYY"
                  slotProps={{
                    desktopPaper: {
                      sx: {
                        "& .MuiPickersCalendarHeader-switchViewButton": {
                          right: "150px",
                        },
                        "& .MuiPickersArrowSwitcher-previousIconButton": {
                          right: "50px",
                        }, // Adjust gap between arrows
                      },
                    },
                    // nextIconButton: {
                    //   sx: {
                    //     background: "red",
                    //   },
                    // },
                  }}
                />
              </Box>
            ))}
          </Stack>
        </LocalizationProvider>
      </div>
      <section className="table_section py-5 pt-3">
        <div className="container">
          {/* <Box sx={{ height: 420, display: "flex", flexDirection: "column" }}>
            <TableContainer
              component={Paper}
              sx={{
                flex: 1,
                overflow: "auto",
                borderRadius: "16px 16px 0px 0",
              }}
            >
              <Table stickyHeader>
                <TableHead sx={{ backgroundColor: "#6e3fc9" }}>
                  <TableRow>
                    {columns.map((col) => (
                      <TableCell
                        key={col.id}
                        align={col.align}
                        sx={headerCellSx}
                      >
                        {col.label}
                      </TableCell>
                    ))}
                  </TableRow>
                </TableHead>

                <TableBody>
                  {isLoading ? (
                    [...Array(limit)].map((_, i) => (
                      <TableRow key={i}>
                        {columns.map((col) => (
                          <TableCell key={col.id}>
                            <Skeleton variant="text" />
                          </TableCell>
                        ))}
                      </TableRow>
                    ))
                  ) : data && data.length > 0 ? (
                    data?.map((row, index) => (
                      <TableRow
                        key={index}
                        sx={{
                          "&:last-child td, &:last-child th": { border: 0 },
                          "&:hover": { backgroundColor: "#f5f5f5" },
                        }}
                      >
                        <TableCell>{(page - 1) * limit + index + 1}</TableCell>
                        <TableCell align="left">
                          {row?.user?.Email || "N/A"}
                        </TableCell>
                        <TableCell align="left">
                          {formatDateTime(row?.loginAt)}
                        </TableCell>
                        <TableCell align="left">
                          {row?.logoutAt
                            ? formatDateTime(row?.logoutAt)
                            : dayjs(row?.loginAt)
                                .add(24, "hour")
                                .isBefore(dayjs())
                            ? formatDateTime(
                                dayjs(row?.loginAt)?.add(24, "hour")
                              )
                            : "Active"}
                        </TableCell>
                        <TableCell align="left">
                          {row?.loginAt && row?.logoutAt
                            ? dayjs
                                ?.duration(
                                  dayjs(row?.logoutAt)?.diff(
                                    dayjs(row?.loginAt)
                                  )
                                )
                                .humanize()
                            : row?.logoutAt || row.lastLogin
                            ? "Active"
                            : dayjs
                                ?.duration(
                                  dayjs(row?.loginAt)
                                    ?.add(24, "hour")
                                    ?.diff(dayjs(row?.loginAt))
                                )
                                .humanize()}
                        </TableCell>
                      </TableRow>
                    ))
                  ) : (
                    <TableRow>
                      <TableCell colSpan={5} align="center" sx={{ py: 3 }}>
                        <div style={{ color: "#666", fontSize: "16px" }}>
                          No records found.
                        </div>
                      </TableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            </TableContainer>
            <Stack
              spacing={2}
              sx={{
                width: "100%",
                alignItems: "flex-end",
                mt: 3,
              }}
            >
              <Pagination
                count={pagination?.totalPages || 1}
                page={page || 1}
                onChange={handlePageChange}
                sx={{
                  "& .MuiPaginationItem-root": {
                    color: "#6e3fc9",
                    borderColor: "#6e3fc9",
                    "&:hover": {
                      backgroundColor: "#f2ecfc",
                    },

                    "&.Mui-selected": {
                      backgroundColor: "#e2d9f7 !important",
                      color: "#4a2b8a !important",
                      fontWeight: "bold",
                      "&:hover": {
                        backgroundColor: "#d1c4f0 !important",
                      },
                    },
                  },
                }}
              />
            </Stack>
          </Box> */}
          <GenericTable
            height={420} // Custom height if you want
            columns={columns}
            data={data}
            isLoading={isLoading}
            page={page}
            totalPages={pagination?.totalPages || 1}
            onPageChange={(page) => handlePageChange(page)}
            headerBgColor="#6e3fc9" // Change color theme anytime
          />
        </div>
      </section>
    </>
  );
};

export default UserActivity;
